import { Component } from '@angular/core';

@Component({
  templateUrl: 'repo.component.html'
})
export class RepoComponent {

  constructor() { 

  } 
}


// WEBPACK FOOTER //
// ./src/app/repoagencies/repo.component.ts